"use strict";

exports.__esModule = true;
exports.getConsumptionDetailsSuccess = exports.getConsumptionDetailsRequest = exports.getConsumptionDetailsFailure = exports.GET_CONSUMPTION_DETAILS_SUCCESS = exports.GET_CONSUMPTION_DETAILS_REQUEST = exports.GET_CONSUMPTION_DETAILS_FAILURE = void 0;

var _appConstants = require("../appConstants");

var GET_CONSUMPTION_DETAILS_REQUEST = "@" + _appConstants.pkgName + "/GET_CONSUMPTION_DETAILS_REQUEST";
exports.GET_CONSUMPTION_DETAILS_REQUEST = GET_CONSUMPTION_DETAILS_REQUEST;
var GET_CONSUMPTION_DETAILS_SUCCESS = "@" + _appConstants.pkgName + "/GET_CONSUMPTION_DETAILS_SUCCESS";
exports.GET_CONSUMPTION_DETAILS_SUCCESS = GET_CONSUMPTION_DETAILS_SUCCESS;
var GET_CONSUMPTION_DETAILS_FAILURE = "@" + _appConstants.pkgName + "/GET_CONSUMPTION_DETAILS_FAILURE";
exports.GET_CONSUMPTION_DETAILS_FAILURE = GET_CONSUMPTION_DETAILS_FAILURE;

var getConsumptionDetailsRequest = function getConsumptionDetailsRequest(payload) {
  return {
    type: GET_CONSUMPTION_DETAILS_REQUEST,
    payload: payload
  };
};

exports.getConsumptionDetailsRequest = getConsumptionDetailsRequest;

var getConsumptionDetailsSuccess = function getConsumptionDetailsSuccess(payload) {
  return {
    type: GET_CONSUMPTION_DETAILS_SUCCESS,
    payload: payload
  };
};

exports.getConsumptionDetailsSuccess = getConsumptionDetailsSuccess;

var getConsumptionDetailsFailure = function getConsumptionDetailsFailure() {
  return {
    type: GET_CONSUMPTION_DETAILS_FAILURE
  };
};

exports.getConsumptionDetailsFailure = getConsumptionDetailsFailure;